/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
export const ACCESS_TOKEN_KEY = "access_token";
export const AUTHORIZATION_OUTSTANDING_KEY = "authorization_outstanding";
